import { ListItem, Text, UnorderedList } from '@chakra-ui/react';

import { Options, documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, Document } from '@contentful/rich-text-types';

interface RichTextProps {
  document: Document;
}

export default function RichText({ document }: RichTextProps) {
  const options: Options = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => <Text mb={4}>{children}</Text>,
      [BLOCKS.UL_LIST]: (node, children) => <UnorderedList mb={4}>{children}</UnorderedList>,
      [BLOCKS.LIST_ITEM]: (node, children) => <ListItem className="rte-list-item">{children}</ListItem>
    }
  };

  const documentAsComponent = documentToReactComponents(document, options);

  return <>{documentAsComponent}</>;
}
